import React from 'react'

export default function BrandAnalyser(props) {
    return (
        <svg {...props} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M9.16667 14.1667C9.16667 15.0507 8.81548 15.8986 8.19036 16.5237C7.56523 17.1488 6.71739 17.5 5.83333 17.5C4.94928 17.5 4.10143 17.1488 3.47631 16.5237C2.85119 15.8986 2.5 15.0507 2.5 14.1667V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5C7.94203 2.5 8.36595 2.67559 8.67851 2.98816C8.99107 3.30072 9.16667 3.72464 9.16667 4.16667V14.1667Z'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.9154 10.8335H15.832C16.2741 10.8335 16.698 11.0091 17.0105 11.3217C17.3231 11.6342 17.4987 12.0581 17.4987 12.5002V15.8335C17.4987 16.2755 17.3231 16.6994 17.0105 17.012C16.698 17.3246 16.2741 17.5002 15.832 17.5002H5.83203'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.83203 14.1665H5.84036'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.16667 6.66654L11.0833 4.74987C11.2694 4.56314 11.4906 4.41503 11.7341 4.31408C11.9776 4.21313 12.2387 4.16131 12.5024 4.16162C12.766 4.16193 13.0269 4.21436 13.2702 4.31588C13.5135 4.41741 13.7344 4.56604 13.92 4.75321L15.5 6.33321C15.6922 6.51805 15.8454 6.73945 15.9508 6.98439C16.0561 7.22932 16.1114 7.49285 16.1135 7.75948C16.1155 8.0261 16.0642 8.29044 15.9625 8.53695C15.8609 8.78345 15.711 9.00715 15.5217 9.19488L8.25 16.4999'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
